var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"0"},attrs:{"src":"https://player.twitch.tv/?channel="+_vm.channel+"&parent="+_vm.location.hostname,"height":_vm.height,"width":_vm.width,"frameBorder":"0","scrolling":"no","allowfullscreen":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }